import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';
import IconMixin from '@rogues/shared/mixins/props/icon';

@Component
/**
 * AlertMe Props
 */
export default class Props extends Mixins(IconMixin) {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Modal theme color
     */
    @Prop({ type: String, default: 'primary' }) color!: string;

    /**
     * channels that available for alert user
     */
    @Prop({ type: [String, Array] }) channels!: string | Array<string>;

    /**
     * Post hashid
     */
    @Prop({ type: String }) postId!: string;
}
